import type { GetApiV1ThreeLetterCodeClientAdminsClient200 } from '@fukuri-admins/apis/client/gen/model';

type IShouldShowDialog = (data: GetApiV1ThreeLetterCodeClientAdminsClient200) => boolean;

/**
 * 送付先住所確認ダイアログの表示判定
 *
 * 以下のすべてを満たす場合に true を返す:
 * - 利用開始カード送付希望（wants_activation_card = true）
 * - 送付先住所が登録済み（shipping_address が存在）
 * - 送付先住所が未確認（shipping_address.confirmed_at = null）
 *
 * 送付先住所が未登録（null）の場合は表示しない。
 *
 * @param data - クライアント情報API レスポンス
 * @returns 表示すべき場合 true、そうでない場合 false
 */
export const shouldShowDialog: IShouldShowDialog = ({ client }) =>
  client.wants_activation_card && client.shipping_address?.confirmed_at === null;
